module.exports = __webpack_public_path__ + "static/media/logo.bf027a5c.png";